module.exports = __webpack_public_path__ + "static/img/Banner_MTS2024_Ticket.bccdef9.jpg";